export const en = {
  // Header
  header: {
    downloadCV: 'Download CV',
  },

  // Banner
  banner: {
    iAm: 'I am',
    location: 'Rodrigo, 21 years old, Florianópolis-SC',
    contactButton: 'Get in Touch',
    portfolioButton: 'My Portfolio',
    typewriter: {
      fullstack: 'FullStack Developer',
      react: 'React Developer',
      shopify: 'Shopify Developer',
      designer: 'UI/UX Designer',
    },
  },

  // About
  about: {
    title: 'About Me',
    subtitle: 'I am a FullStack Developer',
    description: `I'm a Full Stack Developer, graduated in Systems Analysis and Development, with experience in developing web platforms, e-commerces and SaaS systems.

My professional journey started in the creative universe, working as a Graphic Designer, Video Editor and Filmmaker, which gave me a solid foundation in design, usability and user experience. Over time, I found in programming the balance between creativity and logic, an area in which I have been working professionally since 2023.

I worked as the first full-time developer of a health startup, being responsible for building the platform from scratch, participating in architecture decisions, API integrations and development of Artificial Intelligence features aimed at medical support.

I also have experience with e-commerces and internal systems, especially in the Shopify ecosystem, working with Liquid, GraphQL and APIs, in addition to maintaining and developing applications with React, Ruby on Rails, Node.js and PHP.

I have a greater affinity with Front-End, creating intuitive and performative interfaces, but I work completely on the Back-End, always focused on scalable, well-structured and business-oriented solutions.`,
    stats: {
      months: 'Months',
      workExperience: 'Work Experience',
      servicesCompleted: 'Services and Completed Projects',
      coursesCompleted: 'Completed Courses',
    },
    contactButton: 'Get in Touch',
    portfolioButton: 'My Portfolio',
  },

  // WorksText (Experiences)
  worksText: {
    title: 'My Experiences',
    technologies: 'Technologies:',
    experiences: [
      {
        id: 1,
        company: 'HealthTracker',
        period: '02/2025 to 12/2025',
        role: 'Fullstack Developer (PJ)',
        description: [
          'Health Platform Development (HealthTracker Startup)',
          'I worked as the first full-time developer, responsible for building the platform from scratch.',
          'Development of Artificial Intelligence solutions to support doctors in exam analysis.',
          'Architecture and implementation of features using Ruby on Rails, React, JavaScript and REST APIs.',
          'Creation of a robust, scalable and intuitive system, ensuring usability for different user profiles:',
          '• Doctor: full access to patient and exam management and AI chat.',
          '• Patient: sending and tracking exams through the platform.',
          '• Guest doctor: restricted access to view shared patients.',
          '• Collaborator (secretary): administrative panel with controlled permissions.',
          'HealthTracker Landing Page - Development and publication of HealthTracker institutional landing page. Using WordPress for fast, responsive and conversion-optimized construction.',
        ],
        technologies: 'Ruby on Rails, React, JavaScript, REST APIs, WordPress',
      },
      {
        id: 2,
        company: 'HigiePro',
        period: '04/2024 to 12/2024',
        role: 'Fullstack Developer',
        description: [
          'HIGIEPRO PROFESSIONAL HYGIENE PRODUCTS COMPANY.',
          'Seller Portal Project: Building a Seller Portal in Retool, using GraphQL to transform Shopify data into interactive charts and reports, also created functionality for Seller inventory control, so that deliveries were faster, reducing from up to 30 days to delivery, to up to 14 days.',
          'E-commerce Project - Website: Created Prosupply store, a branch of Higiepro, for product sales, development of missing features in shopify.',
          'Loja.Higiepro and Higiepro Project - Website Maintenance: Maintenance of both sites that were made with PHP and Laravel.',
        ],
        technologies: 'GraphQL, Liquid (Shopify), TypeScript, JavaScript, Shopify REST API, Shopify GraphQL API, ReactJs, Node.js, PHP, Laravel, HTML, CSS',
      },
      {
        id: 3,
        company: 'Vista Software',
        period: '07/2023 to 04/2024',
        role: 'Support Analyst',
        description: [
          'Information technology company focused on software and website development, operating in various real estate businesses.',
          'Advanced customization of themes and layouts on real estate websites.',
          'Solving API integration problems and synchronization with external systems.',
          'Creation and configuration of institutional emails.',
          'Implementation and management of websites, from the hosting environment to final delivery.',
        ],
        technologies: 'WordPress, PHP, MySQL, JavaScript, REST API, HTML, CSS',
      },
      {
        id: 4,
        company: 'Floripa Moto Week',
        period: '09/2022 to 12/2024',
        role: 'Full Stack Developer - Official event freelancer',
        description: [
          'Floripa Moto Week is one of the biggest motorcycle events in SC state.',
          'Website project v1 (2023): Created website for Floripa Moto Week, with the aim of adding leads and generating more revenue.',
          'Website project v2 (2024): A website was created with own payment integration, with the aim of adding leads and generating more tickets sold.',
        ],
        technologies: 'WordPress, Elementor, PHP, MySQL, Next.js, ReactJs, Node, PostgreSQL, Prisma (ORM), TypeScript, TailWindCSS, Shadcn',
      },
    ],
  },

  // Work
  work: {
    title: 'My Latest Works.',
    seeAllProjects: 'See all projects on GitHub.',
    seeProject: 'See Project.',
    repository: 'Repository.',
    projects: [
      {
        description: 'Made with WORDPRESS, ELEMENTOR, FIGMA, PHOTOSHOP.\nWebsite for the motorcycle event held since 2023 in Florianópolis\n\nWebsite deactivated by Flavio, returns in the next edition!',
      },
      {
        description: 'Made with ReactJs/NextJs/React Native\nI am developing an application for scheduling beauty salons, or other niches.',
      },
      {
        description: 'Made with LIQUID, JavaScript, HTML.\nI developed a template for HIGIEPRO to use as LandingPage models for their products.',
      },
    ],
  },

  // Work2
  work2: {
    projects: [
      {
        description: 'Made with WORDPRESS, ELEMENTOR, FIGMA, Photoshop.\nWebsite made for Schappo Law Firm, asked me to escape the standards of LAW FIRM templates.\n\nSITE DISCONTINUED, CLIENT ASKED TO STOP MAINTENANCE.',
      },
      {
        description: 'Made with LIQUID, JavaScript\nE-commerce store, made with SHOPIFY, for PROSUPPLY, which belongs to HIGIEPRO, the TRADE template base was used, with customizations made by me, directly in the code.',
        seeProject: 'See Project.',
        repository: 'Repository.',
      },
      {
        description: 'Made with WORDPRESS, ELEMENTOR, FIGMA, Photoshop.\nLanding Page made for the ENCATHO event, this LandingPage will have its second version released on the day of the event',
        repository: 'Repository.',
      },
      {
        description: 'Made with LARAVEL, PHP, HTML, JavaScript\nI provide support for some demands related to this website, the entire home was redone.',
        seeProject: 'See Project.',
      },
    ],
  },

  // Services
  services: {
    title: 'My courses!',
    subtitle: 'here I will list the main ones:',
    seeWorks: 'See my works.',
    courses: [
      {
        name: 'Systems Analysis and Development.',
        description: 'Institution: Descomplica, Start: August/2k23 Expected completion: 2k25.',
      },
      {
        name: 'Complete JavaScript Course',
        description: 'Institution: Danki Code, Workload: 14 hours.',
      },
      {
        name: 'Complete FrontEnd Course',
        description: 'Institution: Danki Code, Workload: 81 hours.',
      },
      {
        name: 'Complete FrontEnd Course 2.0',
        description: 'Institution: Danki Code, Workload: 10 hours.',
      },
      {
        name: 'JavaScript Course - Curso Em Video',
        description: 'Institution: Curso Em Video, Workload: 40 hours.',
      },
    ],
  },

  // Contact
  contact: {
    subtitle: 'My Social Networks!',
    title: 'Get in Touch.',
  },
};

